function useWebEngageLogin() {
  const loginWebEngage = (
    userId: number,
    // token: string,
    firstName: string,
    lastName: string
  ) => {
    try {
      window.webengage.user.login(userId);
      // window.webengage.user.setAttribute("we_hashed_phone", token);
      window.webengage.user.setAttribute("we_first_name", firstName);
      window.webengage.user.setAttribute("we_last_name", lastName);
    } catch (error) {
      console.log("🚀 ~ loginWebEngage ~ error:", error);
    }
  };
  const logoutWebEngage = () => {
    try {
      window.webengage.user.logout();
    } catch (error) {
      console.log("🚀 ~ logoutWebEngage ~ error:", error);
    }
  };

  const signUpWebEngage = (userId: number, token: string) => {
    try {
      window.webengage.user.login(userId);
      window.webengage.track("Sign up Completed");
      window.webengage.user.setAttribute("we_hashed_phone", token);
    } catch (error) {
      console.log("🚀 ~ signUpWebEngage ~ error:", error);
    }
  };

  return { loginWebEngage, logoutWebEngage, signUpWebEngage };
}

export default useWebEngageLogin;
